import { ComputedRef, type Ref, computed } from 'vue'

import { useTr } from '@/composables/use-tr'
import { type APIGameType } from '@/types'

export type GenerateGameHeadParams = {
    game: Ref<APIGameType | undefined>
}

type GamePlatforms = {
    is_ios: boolean
    is_android: boolean
    is_desktop: boolean
}

function getPlatforms(platforms: GamePlatforms) {
    const result: ('ios' | 'android' | 'desktop')[] = []
    if (platforms.is_ios) {
        result.push('ios')
    }
    if (platforms.is_android) {
        result.push('android')
    }
    if (platforms.is_desktop) {
        result.push('desktop')
    }
    return result
}

export function useGamePlatforms(platforms: Ref<GamePlatforms | undefined>): ComputedRef<string> {
    const tr = useTr()
    return computed(() => {
        if (!platforms.value) {
            return ''
        }
        return getPlatforms(platforms.value)
            .map((platform) => {
                switch (platform) {
                    case 'desktop':
                        return tr('gameContainer.desktop')
                    case 'android':
                        return tr('gameContainer.android')
                    case 'ios':
                        return tr('gameContainer.ios')
                }
            })
            .join(', ')
    })
}
